<template>
  <div
    :class="
      isSuperMap()
        ? 'scene-edit-container supermap-box'
        : 'scene-edit-container'
    "
    v-if="isPageVisible">
    <div
      class="header-box"
      :class="showBorder ? 'header-border' : ''">
      <div class="left-box">
        <div
          class="back-icon-box"
          @click="back"
          v-if="!isSuperMap()">
          <icon-svg icon-class="ic-ico_return" />
        </div>
        <div class="tabs-box">
          <div
            :class="`tab-item-box ${isActiveTab('sceneElem') ? 'active' : ''}`"
            @click="setActiveTab('sceneElem')">
            添加元素
          </div>
          <!-- <div
            :class="`tab-item-box ${isActiveTab('seniorObj') ? 'active' : ''}`"
            @click="setActiveTab('seniorObj')"
          >
            高级对象
          </div> -->
        </div>
      </div>
      <div
        class="center-box text-overflow"
        :title="sceneInfo.sceneName">
        {{ sceneInfo.sceneName }}
      </div>
      <div class="right-box">
        <div
          class="scene-elem-buttons"
          v-if="isActiveTab('sceneElem')">
          <div
            class="button-box"
            @click="toggleExceptionData">
            <div class="icon-box">
              <icon-svg icon-class="ic-exception" />
            </div>
            <div>异常状态</div>
          </div>
          <div
            class="button-box"
            @click="openConvertQueueDialog">
            <div class="icon-box">
              <icon-svg icon-class="ic-zhuanhuanjindu" />
            </div>
            <div>任务进度</div>
          </div>
          <div
            v-if="isChecked('Project.Single.Scene.InitPosition')"
            :class="`button-box ${isPosEditMode() ? 'btn-disabled' : ''}`"
            @click="initPosition">
            <div class="icon-box">
              <icon-svg icon-class="ic-chushihuaweizhi" />
            </div>
            <div>初始化位置</div>
          </div>
          <div
            class="button-box"
            @click="toggleSceneInfoDialog">
            <div class="icon-box">
              <icon-svg icon-class="ic-sphere" />
            </div>
            <div>场景信息</div>
          </div>
          <div
            :class="isSuperMap() ? 'button-box' : 'button-box publish-btn-box'"
            @click="publish">
            <div class="icon-box">
              <icon-svg icon-class="ic-fabu" />
            </div>
            <div>发布</div>
          </div>
        </div>
      </div>
    </div>
    <SceneElements
      ref="sceneElem"
      :sceneInfo="sceneInfo"
      :updateSceneInfo="initSceneInfo"
      :openPublishDialog="openPublishDialog" />
    <PublishDialog
      :visible="publishDialogVisible"
      :updateDataSets="updateDataSets"
      :publishScene="publishScene"
      :closeDialog="closePublishDialog" />
    <PublishLoading v-if="publishLoadingVisible" />
    <SceneInfoDialog
      :visible="isSceneInfoDialogVisisble"
      :closeDialog="toggleSceneInfoDialog" />
  </div>
</template>

<script>
import SceneElements from './sceneElements/SceneElements.vue'
import PublishDialog from './sceneElements/components/PublishDialog.vue'
import PublishLoading from './sceneElements/components/PublishLoading.vue'
import SceneInfoDialog from './sceneElements/components/SceneInfoDialog.vue'

import { Store } from '@/utils/store'

import {
  getClientTokenService,
  getRoleMenu,
  getSceneById,
  publishSceneService
} from '@/service/interface'

export default {
  data() {
    return {
      isPageVisible: false,
      showBorder: true,
      activeTab: 'sceneElem',
      sceneInfo: {},
      publishDialogVisible: false,
      updateDataSets: [],
      publishLoadingVisible: false,

      isSceneInfoDialogVisisble: false
    }
  },
  components: {
    SceneElements,
    PublishDialog,
    PublishLoading,
    SceneInfoDialog
  },

  mounted() {
    this.$eventManage.on('dataSetLoadFinish', this.onDataSetLoadFinish)
  },
  created() {
    this.initClientInfo().then(() => {
      this.isPageVisible = true

      this.initSceneInfo()
    })
  },
  beforeRouteLeave(to, from, next) {
    // 防止离开页面后正常点击构件导致高亮整个数据集
    window.BlackHole3D.BIM.setSelMode(1)
    // 防止离开页面后点击正常构件出现包围盒
    window.BlackHole3D.Entity.setBVShpVisiable(false)

    this.timer && clearInterval(this.timer)
    this.timer = null

    let domRef = this.$refs.sceneElem
    domRef.setEngineWorldCRS('')

    this.copyCanvas()
    next()
  },
  methods: {
    onDataSetLoadFinish() {
      this.showBorder = false
    },
    initClientInfo() {
      return new Promise(resolve => {
        if (window.isClientAuthByConfig) {
          this.initClientToken().then(() => {
            this.initClientPermission().then(() => {
              resolve()
            })
          })
        } else {
          resolve()
        }
      })
    },
    initClientToken() {
      return new Promise(resolve => {
        let params = {
          clientId: window.clientId,
          secretKey: window.secretKey,
          userId: window.userId
        }
        getClientTokenService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              sessionStorage.setItem('token', response.token)
              sessionStorage.setItem('tokenId', response.tokenId)
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    initClientPermission() {
      return new Promise(resolve => {
        let params = { menuName: '' }
        getRoleMenu(params).then(res => {
          if (res.status === 200) {
            let response = res.data
            if (response.isSuccess) {
              let permissionData = response.data
              permissionData = this.treeToList(permissionData)
              Store.permissionData = permissionData
              resolve(permissionData)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    initSceneInfo() {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        getSceneById(sceneId).then(response => {
          if (response.isSuccess) {
            let sceneInfo = response.data
            this.sceneInfo = sceneInfo
            resolve()
          }
        })
      })
    },
    toggleExceptionData() {
      this.$refs.sceneElem.toggleExceptionData()
    },
    openConvertQueueDialog() {
      this.$refs.sceneElem.openConvertQueueDialog()
    },
    isPosEditMode() {
      let domRef = this.$refs.sceneElem
      if (domRef) {
        return domRef.isPosEditMode
      } else {
        return false
      }
    },
    initPosition() {
      let domRef = this.$refs.sceneElem
      domRef.initPosition()
    },
    toggleSceneInfoDialog() {
      if (this.isSceneInfoDialogVisisble) {
        this.isSceneInfoDialogVisisble = false
      } else {
        this.isSceneInfoDialogVisisble = true
      }
    },
    publish() {
      let domRef = this.$refs.sceneElem
      domRef.publishCheck().then(checkResult => {
        if (checkResult) {
          this.publishScene(true)
        }
      })
    },
    openPublishDialog(updateDataSets) {
      this.updateDataSets = updateDataSets
      this.publishDialogVisible = true
    },
    closePublishDialog() {
      this.publishDialogVisible = false
    },
    publishScene(ignoreDataSetUpdate) {
      let sceneId = this.$route.query.sceneId
      let nodeBBoxes = this.getBBoxParams()
      let params = { sceneId, ignoreDataSetUpdate, nodeBBoxes }
      publishSceneService(params).then(response => {
        if (response.isSuccess) {
          if (!ignoreDataSetUpdate) {
            let domRef = this.$refs.sceneElem
            domRef.updateSceneTreeStatus()
            domRef.openConvertQueue()
          } else {
            this.publishLoadingVisible = true
            if (!this.timer) {
              this.refreshSceneStatus()
              this.timer = setInterval(this.refreshSceneStatus, 5000)
            }
          }
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    getBBoxParams() {
      let domRef = this.$refs.sceneElem
      let params = domRef.getBBoxParams()
      return params
    },
    refreshSceneStatus() {
      let sceneId = this.$route.query.sceneId
      getSceneById(sceneId).then(response => {
        if (response.isSuccess) {
          let sceneInfo = response.data
          let status = sceneInfo.latestConvertStatus
          if (status === 4) {
            this.timer && clearInterval(this.timer)
            this.timer = null
            this.$message.error('发布失败')
            this.publishLoadingVisible = false
            this.updateDataSets = []
          }
          if (status === 5) {
            this.timer && clearInterval(this.timer)
            this.timer = null
            this.$message.success('发布成功')
            this.publishLoadingVisible = false
            this.updateDataSets = []
          }
        }
      })
    },
    back() {
      let domRef = this.$refs.sceneElem
      domRef.exitCheck().then(result => {
        if (result) {
          let { projId, projName } = this.$route.params
          let { dataType, theme, isHeaderHidden } = this.$route.query
          projName = encodeURIComponent(projName)
          let path = `/singleProject/sceneList/${projId}/${projName}?dataType=${dataType}`
          if (theme) {
            path += `&theme=${theme}`
          }
          if (isHeaderHidden) {
            path += `&isHeaderHidden=true`
          }
          this.$router.push(path)
        }
      })
    },
    setActiveTab(tab) {
      this.activeTab = tab
    },
    isActiveTab(tab) {
      return this.activeTab === tab
    },
    copyCanvas() {
      const canvasBox = document.getElementById('engineCanvas')
      if (canvasBox) {
        const canvasContainer = document.getElementById('canvas-container')
        canvasContainer.append(canvasBox)
      }
    },
    isSuperMap() {
      let path = this.$route.path
      if (path.includes('supermap')) {
        return true
      } else {
        return false
      }
    },
    treeToList(permissionData) {
      let queue = []
      let out = []
      queue = queue.concat(permissionData)
      while (queue.length) {
        let first = queue.shift()
        if (first.childNodes) {
          queue = queue.concat(first.childNodes)
          delete first['childNodes']
        }
        out.push(first)
      }
      return out
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.scene-edit-container {
  position: relative;
  width: 100%;
  max-width: 100% !important;
  height: 100%;
  overflow: hidden;

  .header-border {
    margin-bottom: 2px;
  }
  .header-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    line-height: 64px;
    padding: 0 14px;
    background: var(--header-bg-color);
    // border-bottom: 1px solid var(--scene-edit-border-color);

    .left-box {
      display: flex;
      align-items: center;
      .back-icon-box {
        width: 46px;
        height: 46px;
        border-radius: 16px;
        font-size: 24px;
        padding: 0px 20px;
        color: var(--aside-bg-color);
        background: var(--base-primary-color);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tabs-box {
        display: flex;
        margin-left: 10px;

        .tab-item-box {
          padding: 0px 10px;
          cursor: pointer;

          &:hover {
            color: var(--base-primary-color);
            border-bottom: 2px solid var(--base-primary-color);
          }
        }

        .active {
          color: var(--base-primary-color);
          border-bottom: 2px solid var(--base-primary-color);
        }
      }
    }

    .center-box {
      max-width: 300px;
      overflow: hidden;
      color: var(--scene-edit-header-box-title-color);
    }

    .right-box {
      display: flex;
      .scene-elem-buttons {
        display: flex;
        .button-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: auto 0;
          width: 80px;
          padding: 6px 4px;
          font-size: 12px;
          line-height: 20px;
          cursor: pointer;
          border-radius: 8px;
          cursor: pointer;
          color: var(--scene-edit-header-box-title-text-color);

          &:hover {
            background: var(--scene-edit-header-box-title-hover-bgColor);
            color: var(--scene-edit-header-box-title-hover-text-color);
          }

          &:not(.publish-btn-box:last-child) {
            margin-right: 8px;
          }

          .icon-box {
            font-size: 14px;
            margin-bottom: 4px;
          }
        }

        .btn-disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }
    }
  }
}

.supermap-box {
  height: 100%;

  .tabs-box {
    display: flex;
    margin-left: 10px;

    .tab-item-box {
      padding: 0px 10px;
      cursor: pointer;

      &:hover {
        color: var(--default-color) !important;
        border-bottom: 2px solid var(--default-color) !important;
      }
    }

    .active {
      color: var(--default-color) !important;
      border-bottom: 2px solid var(--default-color) !important;
    }
  }
}
</style>
